import Component from '@glimmer/component';

import { array, concat } from '@ember/helper';
import LinkToAction from 'ember-route-state/components/link-to-action.gjs';

import { classMix } from 'rise-ui/decorators/class-mix.js';
import arrayConcat from 'rise-ui/helpers/array-concat.js';
import classMod from 'rise-ui/helpers/class-mod.js';
import concatClasses from 'rise-ui/helpers/concat-classes.js';
import fnx from 'rise-ui/helpers/fnx.js';
import one from 'rise-ui/helpers/one.js';

export default class AddButtonComponent extends Component {
  /** @type {ClassMix} */
  @classMix classMixed;

  <template>
    {{#let
      (one @title "Add")
      (arrayConcat (array @added "--added") this.classMixed.mixedClassModifiers)
      as | title classModifiers |
    }}
    <span title={{title}} ...attributes>
      <LinkToAction
        @linkClass={{classMod
          (classMod
            (concatClasses "c-add-button" this.classMixed.mixedClassNames)
            @context
            (concat "--" @context "-context")
          )
          modifiers=classModifiers
        }}
        @linkTo={{@linkTo}}
        @action={{fnx @action @added}}
        @disabled={{@disabled}}>
        {{~#if (has-block)}}{{yield}}{{else if @added}}Remove{{else}}Add{{/if~}}
      </LinkToAction>
    </span>
    {{/let}}
  </template>
}
